const rtf = new Intl.RelativeTimeFormat('fr-CA', { numeric: 'auto' })

const longDateFmt = new Intl.DateTimeFormat('fr-CA', {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
})

export function formatRelativeFr(input: Date | string): string {
  const d = typeof input === 'string' ? new Date(input) : input
  const diffMs = Date.now() - d.getTime()
  const diffMin = Math.round(diffMs / 60_000)

  if (Math.abs(diffMin) < 1) return "à l'instant"
  if (Math.abs(diffMin) < 60) return rtf.format(-diffMin, 'minute')

  const diffH = Math.round(diffMin / 60)
  if (Math.abs(diffH) < 24) return rtf.format(-diffH, 'hour')

  const diffD = Math.round(diffH / 24)
  if (Math.abs(diffD) < 30) return rtf.format(-diffD, 'day')

  const diffMonth = Math.round(diffD / 30)
  if (Math.abs(diffMonth) < 12) return rtf.format(-diffMonth, 'month')

  return rtf.format(-Math.round(diffMonth / 12), 'year')
}

export function formatLongDateFr(input: Date | string): string {
  const d = typeof input === 'string' ? new Date(input) : input
  return longDateFmt.format(d)
}

// Date + heure compacte fr-CA (« 3 juill. 2026, 14 h 05 ») pour les fils et
// tableaux d'activité (module Commentaires). NaN → '—'.
const dateTimeFmt = new Intl.DateTimeFormat('fr-CA', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
})

export function formatDateTimeFr(input: Date | string): string {
  const d = typeof input === 'string' ? new Date(input) : input
  return Number.isNaN(d.getTime()) ? '—' : dateTimeFmt.format(d)
}

// Date-only 'YYYY-MM-DD' → forme longue fr-CA (« 24 novembre 2026 »). Formatte
// en UTC : `new Date('YYYY-MM-DD')` est minuit UTC, qu'un format en fuseau
// local (négatif au Québec) ferait reculer d'un jour.
const dateOnlyFmt = new Intl.DateTimeFormat('fr-CA', {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
  timeZone: 'UTC',
})

export function formatDateOnlyFr(dateStr: string): string {
  const d = new Date(`${dateStr}T00:00:00Z`)
  return Number.isNaN(d.getTime()) ? dateStr : dateOnlyFmt.format(d)
}

// Décale une date-only 'YYYY-MM-DD' de `days` jours (calendaire, UTC). Sert aux
// seuils par comparaison de chaînes ISO (ex. échéance à moins de 7 jours).
export function addDaysToDateString(dateStr: string, days: number): string {
  const d = new Date(`${dateStr}T00:00:00Z`)
  d.setUTCDate(d.getUTCDate() + days)
  return d.toISOString().slice(0, 10)
}
